import create from 'zustand';
import { combine } from 'zustand/middleware';
export var useStore = create(combine({
    selectedEntityId: null,
}, function (set, get) { return ({
    api: {
        selectEntity: function (id) { return set({ selectedEntityId: id }); },
    },
}); }));
//# sourceMappingURL=useStore.js.map